<template lang="html">
  <div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
    this.request()
  },
  methods: {
    request () {
      const query = this.$route.query.token
      this.$api.getRequestToSendInfo(query, response => {
        var email = response.data.send_user_info.email
        if (response.err === 0) {
          var uid = localStorage.getItem('uid')
          if (response.data.send_user_info.user_id !== uid) {
            localStorage.removeItem('token')
          }
          this.$router.push({ path: '/app/login?email=' + email + '&upload=' + query })
        } else {
          if (response.data.errno === 226) {
            if (this._global.config.system === 'ios' || this._global.config.system === 'android') {
              this.$router.push({ path: '/app/phone?token=' + query + '&type=upload' })
            } else {
              localStorage.removeItem('token')
              this.$router.push({ path: '/app/login?email=' + email + '&upload=' + query })
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="css">
</style>
